/*
 * @Author: 刘小博
 * @Date: 2023-02-07 17:21:52
 * @LastEditTime: 2023-02-08 11:12:17
 * @LastEditors: 刘小博
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\behavior-manage\behavior-statistics-report\index.js
 * 行为统计报表
 */
import dataAnalyseRouter from './modules/dataAnalyseRouter'
import prescriptionAnalyseRouter from './modules/prescriptionAnalyseRouter'
import retailAnalyseRouter from './modules/retailAnalyseRouter'

const behaviorStatisticReportRouter = [].concat(
  dataAnalyseRouter,
  prescriptionAnalyseRouter,
  retailAnalyseRouter,
)
export default behaviorStatisticReportRouter
